import {
  DEPRECIATION_LOADING,
  GET_DEPRECIATION,
  GET_DEPRECIATION_SUCCESS,
  GET_DEPRECIATION_FAIL,
  ADD_DEPRECIATION_SUCCESS,
  ADD_DEPRECIATION_FAIL,
  DELETE_DEPRECIATION_SUCCESS,
  DELETE_DEPRECIATION_FAIL,
  UPDATE_DEPRECIATION_SUCCESS,
  UPDATE_DEPRECIATION_FAIL,
  DEPRECIATION_RESET,
  DEPRECIATION_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  depreciations: [],
  depreciationAdded: {},
  error: {},
};

const Disposal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEPRECIATION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_DEPRECIATION:
          return {
            ...state,
            depreciations: action.payload.data,
            isDisposalCreated: false,
            isDisposalSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_DEPRECIATION_FAIL:
      switch (action.payload.actionType) {
        case GET_DEPRECIATION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isDisposalCreated: false,
            isDisposalSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_DEPRECIATION: {
      return {
        ...state,
        isDisposalCreated: false,
        loading: true,
      };
    }

    case DEPRECIATION_LOADING: {
      return {
        ...state,
        isDisposalCreated: false,
        loading: true,
      };
    }

    case ADD_DEPRECIATION_SUCCESS:
      return {
        ...state,
        isDisposalCreated: true,
        loading: false,
        depreciations: [action.payload.data, ...state.depreciations],
        depreciationAdded: action.payload.data,
      };

    case ADD_DEPRECIATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_DEPRECIATION_SUCCESS:
      return {
        ...state,
        loading: false,
        depreciations: state.depreciations.filter(
          depreciation => depreciation.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_DEPRECIATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_DEPRECIATION_SUCCESS:
      return {
        ...state,
        loading: false,
        depreciations: state.depreciations.map(depreciation =>
          depreciation.id.toString() === action.payload.data.id.toString() ? { ...depreciation, ...action.payload.data } : depreciation
        ),
      };

    case UPDATE_DEPRECIATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DEPRECIATION_RESET_CREATE:
      return {
        ...state,
        isDisposalCreated: false,
      };

    case DEPRECIATION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Disposal;